import { motion } from "framer-motion";
import ebookImage from "../assets/Online_Best_IT_Tranning_Provider.jpg"; // replace with your uploaded path

const fadeInUp = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

export default function EbookPage() {
  return (
    <section className="bg-gray-50 px-4 py-16 sm:px-10 md:px-20">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        {/* Image */}
        <motion.div
          variants={fadeInUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <img
            src={ebookImage}
            alt="eBook Cover"
            className="w-full rounded-md shadow-lg"
          />
        </motion.div>

        {/* Text Content */}
        <motion.div
          variants={fadeInUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="text-gray-800"
        >
          <h2 className="text-3xl sm:text-4xl font-bold leading-tight">
            The Ultimate Guide to Choosing the{" "}
            <span className="text-orange-500">
              Best Managed IT Service Provider
            </span>
          </h2>

          <p className="mt-6 text-gray-600 leading-relaxed">
            Maximize your organization’s potential with our indispensable asset—
            a free eBook designed for forward-thinking leaders like you.
            This comprehensive guide is your key to unlocking new opportunities
            and expertly navigating the challenges of today’s digital landscape.
          </p>

          <p className="mt-4 text-gray-600 leading-relaxed">
            Download your copy now to start building a more resilient, agile,
            and successful future for your organization with Nadezhda Venture Pvt. Ltd.
          </p>

          <motion.a
            whileHover={{ scale: 1.05 }}
            href="/contact"
            className="inline-block mt-6 bg-orange-500 hover:bg-orange-600 text-white font-semibold px-6 py-3 rounded-full shadow-lg transition-all duration-300"
          >
            Book Now !
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
}
